<template>
  <div class="content_con">
    <p class="text-center" style="margin-bottom: 20px">
      <span class="title">东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        广东东进有害生物防控技术有限公司，拟对东进公司绿化保洁及森林质量提升岗位外包采购项目（采购项目编号：DJFK-GW-05-01-003（2025））所需的服务国内公开采购，欢迎符合资格条件的供应商参加。</span
      >
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      一、<span class="heading">采购项目概况</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、采购项目名称：<span class="underline"
          >&nbsp;东进公司绿化保洁及森林质量提升岗位外包采购项目&nbsp;</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、预算金额（元）：<span class="underline"
          >&nbsp;无具体预算，各项目协议外包供应商以进场通知书要求为准，按实际进场人数、，每月考核后据实结算费用。其中各档位服务费单价=各档位服务费单价限价*（1-中标下浮率）。</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、最高限价（元）：
        <span
          >各档位服务费单价限价详见“第六部分附件－投标文件格式”-“附件3.各档位服务费单价最高限价”。</span
        >
        <span class="underline"
          >&nbsp;（本项目采用下浮率报价，中标后各档位服务费单价=各档位服务费单价限价*（1-中标下浮率）&nbsp;</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 4、项目内容： </span>
    </p>

    <el-table :data="packageTableData" style="width: 100%" border>
      <el-table-column
        prop="packageNo"
        label="采购包号"
        width="50"
        header-align="center"
      />
      <el-table-column
        width="150"
        prop="projectContent"
        label="项目内容"
        header-align="center"
      />
      <el-table-column
        prop="serviceUnitQuantity"
        label="采购服务单位数量"
        width="100"
        header-align="center"
      />
      <el-table-column
        prop="personnelRequirement"
        label="人员要求"
        header-align="center"
      />
      <el-table-column
        prop="serviceTerm"
        label="服务期"
        width="100"
        header-align="center"
      />
      <template slot="append">
        <div style="padding: 10px 20px; color: #000; font-weight: 700">
          注：本项目A、B包不可兼投兼中。
        </div>
      </template>
    </el-table>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        5、项目需求
        <p>详细内容请参阅采购文件第三部分《用户需求书》。</p>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      二、<span class="heading">投标人资格要求</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content"> 1、一般要求： </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（1）</span>
      <span class="content"
        >投标人须为在中华人民共和国境内登记注册的具有独立承担民事责任能力的法人或其他组织【提供《营业执照》复印件（加盖公章）或《事业单位法人证书》复印件（加盖公章）或其他主体证书复印件（加盖公章）】。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（2）</span>
      <span class="content"
        >参加采购活动前三年内，在经营活动中没有重大违法记录（须提供书面声明）。重大违法记录，是指供应商因违法经营受到刑事处罚或者责令停产停业、吊销许可证或者执照、较大数额罚款等行政处罚。（根据财库〔2022〕3号文，“较大数额罚款”认定为200万元以上的罚款，法律、行政法规以及国务院有关部门明确规定相关领域“较大数额罚款”标准高于200万元的，从其规定，如有最新发文通知，按最新文件执行）。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（3）</span>
      <span class="content"
        >投标人的单位负责人为同一人或者存在直接控股、管理关系的不同投标人，不得参加同一合同项下的采购活动。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（4）</span>
      <span class="content"
        >未被列入“信用中国”网站(www.creditchina.gov.cn
        )“记录失信被执行人或重大税收违法失信主体或政府采购严重违法失信行为”记录名单。以代理机构于投标截止日当天在“信用中国”网站查询结果为准，如相关失信记录已失效，投标人需提供相关证明资料。
      </span>
    </p>
    <p class="text-indent-37 line-height-39 text-autospace">
      <span class="number">（5）</span>
      <span class="content"
        >未被列入东实集团及下属企业相关领域黑名单。【以东莞实业投资控股集团有限公司发文（东实通〔2021〕44号）、（东实通〔2021〕98号）、（东实通〔2022〕75号）、（东实通〔2023〕37号）和下属公司发文为准，如有最新发文通知，按最新文件执行。】
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      三、<span class="heading">获取采购文件方式及要求：</span>
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span
          >本项目不进行实名登记报名，拟参加投标的投标人可于投标截止时间前自行网上下载采购文件。采购文件下载地址：东莞实业投资控股集团有限公司-招标采购栏目（http://www.dgsy.com.cn/）、广东东进有害生物防控技术有限公司(http://www.tonking.com.cn/)。
        </span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      四、<span class="heading">投标文件的递交：</span>
    </p>

    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、<span
          >递交投标文件时间：
          <span class="block"
            >2025年 <span class="underline">9</span>月
            <span class="underline">22</span>日（北京时间）
            <span class="underline">14:30（星期一）</span></span
          ></span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、<span
          >递交投标文件截止及开标时间：
          <span class="block"
            >2025年 <span class="underline">9</span>月 <span class="underline">22</span>日
            <span class="underline">14:30（北京时间）</span></span
          >，所有投标文件应于截止时间之前递交，迟交或以电报、传真形式的投标文件将拒绝接收。</span
        >
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        3、<span>开标地点：东莞市南城街道中天商业街28号1栋209室东进公司。</span>
      </span>
    </p>

    <p class="text-left text-indent-37 line-height-39 content">
      五、<span class="heading">发布公告的媒介：</span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        1、<span
          >采购公告发布媒介：
          <p>
            东莞实业投资控股集团有限公司-招标采购栏目（http://www.dgsy.com.cn/）、广东东进有害生物防控技术有限公司(http://www.tonking.com.cn/)。
          </p>
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        2、<span
          >结果公告发布媒介：
          <p>
            东莞实业投资控股集团有限公司-招标采购栏目（http://www.dgsy.com.cn/）、广东东进有害生物防控技术有限公司(http://www.tonking.com.cn/)。
          </p>
        </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39 content">
      六、<span class="heading">采购人名称、地址和联系方法：</span>
    </p>
    <!--  -->
    <!--  -->
    <!--  -->
    <!--  -->
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>采购人名称：广东东进有害生物防控技术有限公司 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>采购人联系人：杨先生 </span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>采购人地址：东莞市南城街道中天商业街28号1栋209室</span>
      </span>
    </p>
    <p class="text-left text-indent-37 line-height-39">
      <span class="content">
        <span>采购人联系电话：0769-22008298</span>
      </span>
    </p>

    <p class="text-right text-indent-37 line-height-39">
      <span class="content"> 采购人：广东东进有害生物防控技术有限公司</span>
    </p>
    <p class="text-right text-indent-37 line-height-39">
      <span class="content"> 2025年9月4日</span>
    </p>

    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif" /></a
      ><a
        class="file-link"
        href="/20250908/东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告.doc"
        title="东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告.doc"
        >东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告.doc</a
      >
    </p>
    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif" /></a
      ><a
        class="file-link"
        href="/20250908/东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告.pdf"
        title="东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告.pdf"
        >东进公司绿化保洁及森林质量提升岗位外包采购项目采购公告.pdf</a
      >
    </p>
    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_doc.gif" /></a
      ><a
        class="file-link"
        href="/20250908/东进公司绿化保洁及森林质量提升岗位外包采购项目招标文件.doc"
        title="东进公司绿化保洁及森林质量提升岗位外包采购项目招标文件.doc"
        >东进公司绿化保洁及森林质量提升岗位外包采购项目招标文件.doc</a
      >
    </p>
    <p class="file-link-box">
      <a
        class="group1 cboxElement"
        href="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif"
        title=""
        ><img
          class="icon"
          src="http://www.dgsy.com.cn/include/ueditor/dialogs/attachment/fileTypeImages/icon_pdf.gif" /></a
      ><a
        class="file-link"
        href="/20250908/东进公司绿化保洁及森林质量提升岗位外包采购项目招标文件.pdf"
        title="东进公司绿化保洁及森林质量提升岗位外包采购项目招标文件.pdf"
        >东进公司绿化保洁及森林质量提升岗位外包采购项目招标文件.pdf</a
      >
    </p>
  </div>
</template>
<script>
export default {
  name: "DocDisplay",
  data() {
    return {
      packageTableData: [
        {
          packageNo: "A",
          projectContent: "绿化保洁岗位",
          serviceUnitQuantity: "4家",
          personnelRequirement:
            "年龄不超过50周岁，身体健康，形象较好，小学或以上文化程度。具有一定的绿化养护基础知识。",
          serviceTerm: "2年",
        },
        {
          packageNo: "B",
          projectContent: "森林质量提升岗位",
          serviceUnitQuantity: "3家",
          personnelRequirement:
            "需要满足采购方在合同中项目需求，作业人员需有森林质量提升岗位经验且年龄大于25岁，不超过55岁。",
          serviceTerm: "2年",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.star {
  display: inline-block;
  color: black;
  width: 15px;
  height: 15px;
  position: relative;
}
.star::before,
.star::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 15px;
  height: 15px;
  background: currentColor;
  clip-path: polygon(
    50% 0%,
    61% 35%,
    98% 35%,
    68% 57%,
    79% 91%,
    50% 70%,
    21% 91%,
    32% 57%,
    2% 35%,
    39% 35%
  );
}

.underline {
  text-decoration: underline;
  text-underline-offset: 5px;
}

.content_con {
  font-size: 14px;
  font-family: "宋体", Arial;
  padding: 0px 50px;
  color: #515050;

  a {
    text-decoration: none;
    color: inherit;
  }

  .fa {
    color: #333;
    font-size: 12px;
  }

  .line-height-2em {
    line-height: 2em;
  }

  .text-center {
    text-align: center;
  }

  .margin-bottom-21 {
    margin-bottom: 21px;
  }

  .title {
    font-size: 27px;
    font-family: 方正小标宋简体;
  }

  .text-indent-37 {
    text-indent: 37px;
  }

  .line-height-39 {
    line-height: 39px;
  }

  .content {
    font-weight: 200;
    font-size: 19px;
    font-family: 仿宋_GB2312;
  }

  .heading {
    font-size: 19px;
    font-family: 黑体;
  }

  .block {
    font-family: 黑体;
    color: #000;
    font-weight: 500;
  }

  .red_text {
    color: red;
  }

  .number {
    font-size: 19px;
    font-family: "Times New Roman", "serif";
  }

  .underline {
    text-decoration: underline;
  }

  .text-left {
    text-align: left;
  }
  .text-right {
    text-align: right;
  }

  .text-autospace {
    margin: 3px;
    padding: 3px;

    span {
      color: #515050;
      font-size: 14px !important;
    }
  }

  .icon {
    vertical-align: middle;
    margin-right: 2px;
  }

  .file-link-box {
    margin: 3px;
    padding: 3px;
    font-size: 14px;
    text-indent: 22px;
    line-height: 16px;
  }

  .file-link {
    font-size: 12px;
    color: #0066cc;
  }
}
</style>
